<template>
  <div id="shop-list">
    <call />
    <pop-alert />
    <top-bar title="ショップ一覧" backUrl="/" :customClass="customClass"/>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="search"></footer-app>
      <!-- search -->
      <section :class="{ 'fade-base': true, fade: pageFade }">
        <div class="l-search__head">
          <div class="l-search__head--white">
            <ul class="c-tab-category">
              <li
                class="c-tab-category__item"
                :class="{
                  'is-active':
                    shopCategoryType == 0 && shopType !== 'reservation',
                }"
                v-on:click="getShopCategoryType(0)"
              >
                <a>すべて</a>
              </li>
              <li
                class="c-tab-category__item"
                v-if="isReservationEnabled"
                :class="{
                  'is-active':
                    shopCategoryType == 0 && shopType == 'reservation',
                }"
                v-on:click="getShopCategoryType(0, 'reservation')"
              >
                <a>来店予約</a>
              </li>
              <li
                class="c-tab-category__item"
                v-for="(category, index) in shopCategoryTypes"
                :key="index"
                :class="{ 'is-active': shopCategoryType == category.id }"
                v-on:click="getShopCategoryType(category.id)"
              >
                <a>{{ category.name }}</a>
              </li>
            </ul>
          </div>
          <div class="l-search">
            <div class="l-search__box-search">
              <div class="l-search__box-search--box d-flex c-box-coupon">
                <div class="c-box-coupon__search">
                  <input
                    type="text"
                    placeholder="検索キーワード"
                    v-model="inputSearch"
                  />
                  <div @click.prevent="searchName()">
                    <img
                      src="/assets/images/icon/icon-search-white.svg"
                      width="16"
                      height="16"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-search__body">
            <div class="l-switch-view">
              <div class="l-search__title">
                ショップ一覧 ({{ totalProviders }})
              </div>
              <switch-favorite :isFavorite="isFavorite" :toggleFavorite="toggleFavorite" />
            </div>
            <ul class="c-list-shop mb-24" v-if="providers.length > 0">
              <li v-for="(item, index) in providers" :key="index" v-show="!isFavorite || (follows.includes(item.id) && isFavorite)">
                <div class="c-list-shop__item">
                  <div class="c-list-shop__img_line">
                    <div
                      class="c-list-shop__img js-keep-ratio"
                      data-ratio="1"
                      v-on:click="openModalDetail(item.id)"
                    >
                      <img v-lazy="getImgSrc(item.image[0])" alt="" />
                    </div>
                  </div>
                  <div class="c-list-shop__info">
                    <div class="c-list-shop__info--category">
                      <span
                        class="c-list-shop__info--category--name"
                        :style="{
                          backgroundColor: shopCategoryTypes.find(
                            (category) => category.id == item.shopCategoryType
                          )?.color,
                        }"
                      >
                        {{
                          shopCategoryTypes.find(
                            (category) => category.id == item.shopCategoryType
                          )?.name
                        }}
                      </span>
                    </div>
                    <div
                      class="c-list-shop__info--name font-bold"
                      v-on:click="openModalDetail(item.id)"
                    >
                      {{ item.shopName }}
                    </div>
                    <div class="c-list-shop__info--text">
                      <div
                        class="c-list-shop__info--area"
                        v-on:click="openModalDetail(item.id)"
                      >
                        {{ item.location }}
                      </div>
                      <favorite-icon
                        :isActive="follows.includes(item.id)"
                        :toggleFavorite="follows.includes(item.id) ? () => deleteFollows(item.id) : () => addFollows(item.id)"
                      />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div v-else>条件に一致しませんでした</div>
          </div>
        </div>
        <!-- modal show required login -->
        <modal :open="openModal" @close="() => {
          openModal = false;
          this.$router.push({ query: {} });
        }">
          <shop-detail
            :providerId="providerId"
            :toggleFavoriteShop="(id) => follows.includes(id) ? deleteFollows(id) : addFollows(id)"
            :isActive="(id) => follows.includes(id)"
          />
        </modal>
        <modal_login_required></modal_login_required>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getProviderByShopCategory } from "../store/firestore.js";
import PopAlert from "../components/PopAlert.vue";
import FavoriteIcon from "../components/FavoriteIcon.vue";
import SwitchFavorite from "../components/SwitchFavorite.vue";
import TopBar from "../components/TopBar.vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import Modal from "../components/Modal.vue";
import ShopDetail from "./ShopDetail.vue";


export default Vue.extend({
  name: "ShopList",
  components: {
    "footer-app": Footer,
    PopAlert,
    FavoriteIcon,
    SwitchFavorite,
    TopBar,
    'modal_login_required': ModalLoginRequired,
    Modal,
    ShopDetail,
  },
  mixins: [Tenant],
  data() {
    return {
      queryShopType: this.$route.query.type || null,
      shopType: this.$route.query.type || null,
      shopCategoryType: this.$route.params.category || 0,
      providers: [],
      inputSearch: "",
      totalProviders: 0,
      shopCategoryTypes: [
        { id: 1, name: "スーパーマーケット・総合スーパー", color: "#bc399b" },
        { id: 2, name: "ファッション", color: "#FF8773" },
        { id: 3, name: "グッズ", color: "#FF9F4B" },
        { id: 4, name: "サービス", color: "#18c173" },
        { id: 5, name: "グルメ＆フード", color: "#F1BF41" },
        { id: 6, name: "アミューズメント", color: "#4b98e5" },
      ],
      isReservationEnabled: false,
      isFavorite: false,
      openModal: false,
      providerId: null,
    };
  },
  watch: {
    '$route.query': {
      handler: function (newVal) {
        if (!newVal.id) {
          this.openModal = false
          return;
        }
        this.providerId = newVal.id;
        this.openModal = true;
      },
      immediate: true
    }
  },
  created() {
    this.inputSearch = this.$route.query.keyword;
    this.getDataListProviders(this.shopCategoryType);
    this.getReservationEnabled();
  },
  computed: {
    customClass() {
      return this.$route.query.from == 'top' ? 'z-hidden' : '';
    }
  },
  mounted() {
    Common.initDom();
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio();
    });
  },
  methods: {
    async getReservationEnabled() {
      const result = await getProviderByShopCategory(0);
      if (!result) return;
      //来店予約の場合ここでさらに絞り込む
      var arr = [];
      for (var i = 0; i < result.length; i++) {
        //来店予約のある店舗を検索
        if (result[i].reservationEnabled) {
          arr.push(result[i]);
        }
      }
      this.isReservationEnabled = arr.length > 0 ? true : false;
    },
    async getDataListProviders(categoryType, type) {
      const result = await getProviderByShopCategory(categoryType);
      if (!result) return;
      this.providers = result;

      //来店予約の場合ここでさらに絞り込む
      if (type == "reservation") {
        var arr = [];
        for (var i = 0; i < result.length; i++) {
          //来店予約のある店舗を検索
          if (result[i].reservationEnabled) {
            arr.push(result[i]);
          }
        }
        this.providers = arr;
      }
      if (this.inputSearch) {
        // キーワード検索
        this.providers = this.providers.filter((provider) => {
          const searchText = this.inputSearch.replace(/　/g, " ");
          const searchTexts = searchText.split(" ");
          let hit = true;
          for (let i = 0; i < searchTexts.length; i++) {
            if (searchTexts[i]) {
              const text = searchTexts[i].toUpperCase();
              if (
                provider.shopName.toUpperCase().indexOf(text) === -1 &&
                provider.about.toUpperCase().indexOf(text) === -1
              ) {
                hit = false;
                break;
              }
            }
          }
          return hit;
        });
      }

      await this.getTotalListProviders();
    },
    async getTotalListProviders() {
      this.totalProviders = Object.keys(this.providers).length;
    },
    getShopCategoryType(categoryType, type = null) {
      this.shopType = type;
      this.shopCategoryType = categoryType;
      this.getDataListProviders(categoryType, type);
    },
    searchName() {
      this.getDataListProviders(this.shopCategoryType, this.shopType);
    },
    toggleFavorite() {
      this.isFavorite = !this.isFavorite;
    },
    openModalDetail(providerId) {
      this.providerId = providerId;
      this.$router.push({ query: { id: providerId } });
      this.openModal = true;
    },
  },
});
</script>